module.exports = {"430223001":"联星街道","430223002":"江桥街道","430223003":"春联街道","430223004":"谭桥街道","430223102":"酒埠江镇","430223103":"桃水镇","430223106":"网岭镇","430223109":"渌田镇","430223115":"石羊塘镇","430223118":"黄丰桥镇","430223119":"鸾山镇","430223120":"丫江桥镇","430223122":"皇图岭镇","430223123":"新市镇","430223124":"菜花坪镇","430223125":"莲塘坳镇","430223126":"宁家坪镇","430223400":"攸县工业园","430223401":"攸县网岭循环经济园"}


//////////////////
// WEBPACK FOOTER
// ./src/town/430223.json
// module id = 1820
// module chunks = 0